export const contactPhoneNumber = '+374 11700500';
export const contactHeaderPhoneNumber = '+374 60700500';
export const contactEmail = 'alfapharm@alfapharm.am';